module.exports = __webpack_public_path__ + "img/swiper-24.765d8f12.png";